var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "chip",
      class: _vm.classes,
      attrs: {
        href: "#",
        role: "option",
        tabindex: _vm.disabledInternal ? -1 : null,
        "aria-disabled": _vm.disabledInternal ? "true" : "false",
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.onClick.apply(null, arguments)
        },
        keyup: _vm.onKeyUp,
      },
    },
    [
      _c(
        "span",
        { staticClass: "chip__item" },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.removableInternal && !_vm.disabledInternal
            ? _c(
                "span",
                {
                  staticClass: "chip__removeBtn",
                  attrs: { "aria-hidden": "true" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.onRemoveClick.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._t("removeIcon", function () {
                    return [_vm._v("×")]
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }